import { set, useForm } from "react-hook-form";
import { ListaActividad } from "../../models/riesgo/ListaActividad";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Criterios } from "./Criterios";
import { Actor } from "./Actor";
import { ProgressSpinner } from "primereact/progressspinner";

export const Actividad = ({ riesgo, id, toast, permss, generic, seccion, nextPrev, handleNext, registrar, siguienteTab, setSiguienteTab, setLoadingSave, setLoadingNext, funcionalidades }) => {
    const omodel = new ListaActividad();
    const defaultValues = generic.default(omodel.model);
    const [registers] = useState(null);
    const [selected, setSelected] = useState(null);
    const [items, setItems] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [listar, setListar] = useState(null);
    const [seleccionar, setSeleccionar] = useState(false);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [padreId, setPadreId] = useState(null);
    const [macro, setMacro] = useState(null);
    const [proceso, setProceso] = useState(null);
    const [titulo, setTitulo] = useState(null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const matrizSrv = new MonitoreoService();
    const { inDrop, inAutocomplete } = InputComponent({ registers: registers, omodel, generic, errors, control, permss, id: getValues('id') });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        consultar();
    }, []);

    const consultar = () => {
        setLoading(true);
        const ids = id ?? getValues('id') ?? 0;
        matrizSrv.consultar(`${ids}/${riesgo?.id}/${seccion}`, 'matriz-riesgo-detalle/consulta').then(res => {
            const _riesgo = res.data?.info;
            if (_riesgo) {
                setMacro(_riesgo?.macroproceso_tipo?.cat_id);
                setProceso(_riesgo?.proceso?.cat_id);
                reset(generic.renewValues(_riesgo, omodel.model));
            } else {
                reset(defaultValues);
            }
            setCatalogos(res.data?.catalogos);
        }).finally(() => setLoading(false));
    }

    const searchActividad = (event) => {
        if (!event.query.trim().length) {
            setItems([...items]);
        } else {
            matrizSrv.autoListaMatriz(`matriz-riesgo-criterio/nbuscar/MTR_RIESGO_ACTIVIDAD`, event.query.toLowerCase(), riesgo?.id).then(res => {
                setItems(res.data);
            });
        }
    }

    const seleccion = (info, listado) => {
        if (listar === 'solo') {
            const _catalogos = catalogos;
            _catalogos[tipo] = listado;
            setCatalogos(_catalogos);
        } else {
            setValue('actividad', info);
            setDialogCriterio(false);
            setTipo(null);
            setSeleccionar(null);
            setListar(null);
        }
    }

    const onSubmit = (data) => {
        const ids = id ?? getValues('id') ?? 0;
        data.idp = riesgo?.id;
        data.seccion = seccion;
        setLoadingSave(true);
        setLoadingNext(true);
        if (ids <= 0) {
            matrizSrv.nuevo(data, 'matriz-riesgo-detalle/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                registrar(res.data);
                if (siguienteTab) {
                    setSiguienteTab(false);
                    handleNext();
                }
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoadingSave(false);
                setLoadingNext(false);
            });
        } else {
            data.id = ids;
            matrizSrv.editar(data, 'matriz-riesgo-detalle/editar').then(res => {
                generic.funcSuccess(res, toast);
                if (siguienteTab) {
                    setSiguienteTab(false);
                    handleNext();
                }
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoadingSave(false);
                setLoadingNext(false);
            });
        }
    }

    const criterios = (opc, ccampo, lis = 'solo', sel = false) => {
        if (opc === 'MTR_RIESGO_ACTIVIDAD') {
            setValue('actividad', null);
        }
        setTitulo(omodel?.model[ccampo]?.header);
        setTipo(opc);
        setDialogCriterio(true);
        setSeleccionar(sel);
        setListar(lis);
        if (ccampo === 'macroproceso_categoria') {
            setPadreId(macro);
        } else if (ccampo === 'subproceso') {
            setPadreId(proceso);
        } else {
            setPadreId(null);
        }
    }

    const cerrar = () => {
        setDialogCriterio(false);
        setTipo(null);
        setSeleccionar(null);
        setListar(null);
    }

    const onChangeCriterio = (e, _tipo) => {
        const _field = _tipo === 'MTR_RIESGO_MACRO_CAT' ? 'macroproceso_categoria' : 'subproceso';
        setValue(_field, null);
        const _catalogos = catalogos;
        _catalogos[_tipo] = [];
        setCatalogos(_catalogos);
        if (_tipo === 'MTR_RIESGO_MACRO_CAT') {
            setMacro(e.value?.cat_id ?? null);
        } else {
            setProceso(e.value?.cat_id ?? null);
        }
        if (!e.value) {
            setPadreId(null);
            return;
        }
        setPadreId(e.value?.cat_id);
        matrizSrv.consultar(e.value?.cat_id, 'matriz-riesgo-criterio/subcriterios', { matrizId: riesgo?.id }).then(res => {
            setCatalogos((prev) => ({
                ...prev,
                [_tipo]: res.data
            }));
        });
    }

    return (
        <>
            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', color: '#444', fontWeight: '500', fontSize: '1.2rem' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth={5} />
                    <span style={{ marginTop: '1rem' }}>Cargando información...</span>
                </div>
            ) : (
                <div className="formgrid grid">
                    <div className="field col-8">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="formgrid grid">
                                {inAutocomplete('actividad', selected, setSelected, items, searchActividad, { lab: 'nombre', customLabel: 'Actividad (sobre la que se identifica el riesgo)', col: 11, noEsActividad: true })}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', paddingTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Registrar y Buscar"
                                        onClick={() => criterios('MTR_RIESGO_ACTIVIDAD', 'actividad', 'ninguno', true)} />
                                </div>

                                {inDrop('area', catalogos?.MTR_RIESGO_AREA, { lab: 'nombre' }, 5)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', paddingTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir áreas"
                                        onClick={() => criterios('MTR_RIESGO_AREA', 'area')} />
                                </div>

                                <div className="col-6"></div>

                                {inDrop('macroproceso_tipo', catalogos?.MTR_RIESGO_MACRO_TIPO, { lab: 'nombre', chn: onChangeCriterio, val: 'MTR_RIESGO_MACRO_CAT' }, 5)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', paddingTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir tipo por macroproceso"
                                        onClick={() => criterios('MTR_RIESGO_MACRO_TIPO', 'macroproceso_tipo')} />
                                </div>

                                {inDrop('macroproceso_categoria', catalogos?.MTR_RIESGO_MACRO_CAT, { lab: 'nombre', ne: macro === null }, 5)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', paddingTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir catagoría por macroproceso"
                                        onClick={() => criterios('MTR_RIESGO_MACRO_CAT', 'macroproceso_categoria')} disabled={macro === null} />
                                </div>

                                {inDrop('proceso', catalogos?.MTR_RIESGO_PROCESO, { lab: 'nombre', chn: onChangeCriterio, val: 'MTR_RIESGO_SUBPROCESO' }, 5)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', paddingTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir proceso"
                                        onClick={() => criterios('MTR_RIESGO_PROCESO', 'proceso')} />
                                </div>

                                {inDrop('subproceso', catalogos?.MTR_RIESGO_SUBPROCESO, { lab: 'nombre', ne: proceso === null }, 5)}
                                <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', paddingTop: '1.85rem' }}>
                                    <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Añadir subproceso"
                                        onClick={() => criterios('MTR_RIESGO_SUBPROCESO', 'subproceso')} disabled={proceso === null} />
                                </div>
                            </div>

                            {nextPrev('siguiente')}
                        </form>
                    </div>
                    <div className="field col-4">
                        {id && catalogos?.MTR_RIESGO_ACTOR_INTERNO !== undefined && <Actor toast={toast} permss={permss} generic={generic} riesgo={riesgo} id={id} catalogo={catalogos} funcionalidades={funcionalidades} />}
                    </div>
                </div>
            )}
            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                cerrar();
            }}
                style={{ maxWidth: '500px' }}>
                {tipo !== null && seleccionar !== null &&
                    <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={seleccionar} listar={listar} padreId={padreId} funcionalidades={funcionalidades} />}
            </Dialog>
        </>
    )
}
